







import {Component, Prop, Vue} from "vue-property-decorator";
import FavoriteIcon from "./FavoriteIcon.vue"

@Component({
    name: "FavoritesSwitcher",
    components: { FavoriteIcon }
})
export default class FavoritesSwitcher extends Vue {
    @Prop() value: boolean;
    @Prop({default: false}) stopPropagation: boolean;

    get model() {
        return this.value;
    }

    set model(value: boolean) {
        this.$emit("input", value);
        this.$emit("changed", value);
    }

    onClick(e: MouseEvent) {
        if (this.stopPropagation) {
            e.stopPropagation();
        }
    }
}
